import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class AttributesGroupsActionsValidator {

    name = [
        Validators.required
    ];

    // Error messages
    errorMessages = {
        name: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}